<article class="block-play-cta-end section-inset-y scroll-trigger">
  <section class="container">
    <div class="row">
      <header class="block-play-cta-end__header col-12 col-md-10 offset-md-1 text-center">
        <app-text-shape
          class="block-play-cta-end__arrow-1"
          [shapeColor]="'secondary'"
          [shape]="'arrow-20'"
          [startAnimation]="inviewPort"
        ></app-text-shape>
        <h2 class="h1 block-play-cta-end__subtitle anim-fade-up" [innerHTML]="block.subtitle | uppercase"></h2>
        <h1 class="block-play-cta-end__title text-primary-gradient anim-fade-up delay--1">
          {{ block.title | uppercase }}
        </h1>
        <div class="mt-2 anim-fade-up delay--2">
          <fstr-link
            cssClasses="button button button--primary-gradient has--dot "
            [class.anim-fade-up]="inviewPort"
            [button]="block.button!"
          >
            <ng-container *ngIf="!block.button?.text">{{ 'lees-meer' | fromDictionary }}</ng-container>
          </fstr-link>
        </div>
        <fstr-icon class="block-play-cta-end__icon-2" anchor="icon-doodle-play-button"></fstr-icon>
      </header>
    </div>
    <div class="pull-s background-dots-play-slide"></div>
  </section>
</article>
